<template>
    <div class="check_ele_wrap">
        <div class="search-wrap">
            <el-form
                :model="model"
                ref="modelRef"
                class="leader-style-form"
                label-width="100px"
                :inline="true"
                style="text-align: left"
            >
                <el-form-item label="公司名">
                    <el-input
                        v-model="model.target_unit_name"
                        maxlength="200"
                        placeholder="请输入公司名"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="月份"
                    prop="show_month"
                  
                >
                    <el-date-picker
                        v-model="model.show_month"
                        type="month"
                        placeholder="请选择日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button type="primary" @click="addNew">新增</el-button>
                    <el-button type="primary" @click="getChargeListElec"
                        >查询</el-button
                    >
                    <!-- <el-button type="primary" @click="exportExcel"
                        >导出</el-button
                    > -->
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap-inner">
            <el-table border :data="tableData" class="leader-style-table">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>{{
                            (pageNum - 1) * pageSize + scope.$index + 1
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="公司名"
                    align="center"
                    prop="target_unit_name"
                    width="350px"
                ></el-table-column>
                <el-table-column
                    label="时间"
                    align="center"
                    prop="show_month"
                    width="100px"
                ></el-table-column>
                <el-table-column
                    label="分时时段电费总和"
                    align="center"
                    prop="schedule_money"
                ></el-table-column>
                <el-table-column
                    label="基本电费分摊"
                    align="center"
                    prop="base_total_money"
                ></el-table-column>
                <el-table-column
                    label="线损分摊"
                    align="center"
                    prop="line_loss_total_money"
                ></el-table-column>
                <el-table-column
                    label="公摊费用-峰"
                    align="center"
                    prop="common_peak_total_money"
                ></el-table-column>
                <el-table-column
                    label="公摊费用-平"
                    align="center"
                    prop="common_off_total_money"
                ></el-table-column>
                <el-table-column
                    label="公摊费用-谷"
                    align="center"
                    prop="common_shoulder_total_money"
                ></el-table-column>
                <el-table-column
                    label="备用电源"
                    align="center"
                    prop="back_total_money"
                ></el-table-column>
                <el-table-column
                    label="修正值"
                    align="center"
                    prop="revise"
                ></el-table-column>
                <el-table-column
                    label="总费用"
                    align="center"
                    prop="total_money"
                ></el-table-column>
                <el-table-column
                    label="备注"
                    align="center"
                    prop="revise_reason"
                ></el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button
                            @click="handleEditInfo(scope.row)"
                            type="text"
                            class="leader-button"
                            >修改</el-button
                        >
                        <el-button
                            @click="handleDelete(scope.row)"
                            type="text"
                            class="leader-button"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                class="leader-style-pagination pagination"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <!-- 添加 -->
        <add-dialog
            :addVisible.sync="addVisible"
            @addComplete="addComplete"
        ></add-dialog>
        <!-- 修改 -->
        <edit-dialog
            :editVisible.sync="editVisible"
            :selectPoint="selectPoint"
            @editComplete="editComplete"
        ></edit-dialog>
    </div>
</template>
<script>
import addDialog from "./components/check_fee_add.vue";
import editDialog from "./components/check_fee_edit.vue";
import * as api from "@/http/api.js";
export default {
    components: {
        "add-dialog": addDialog,
        "edit-dialog": editDialog
    },
    data() {
        return {
            model: {
                target_unit_name: "",
                show_month: ""
            },
            tableData: [],
            pageNum: 1,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            totalPage: 0,
            selectPoint: {},
            addVisible: false,
            editVisible: false
        };
    },
    created() {
        this.getChargeListElec();
    },
    methods: {
        // 获得列表
        getChargeListElec() {
            if (this.$refs["modelRef"]) this.$refs["modelRef"].clearValidate();
            api.getChargeListElec({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                target_unit_name: this.model.target_unit_name,
                show_month: this.model.show_month
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.tableData = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        addNew() {
            this.$refs["modelRef"].clearValidate();
            this.addVisible = true;
        },
        handleEditInfo(row) {
            this.editVisible = true;
            this.selectPoint = row;
        },
        handleDelete(row) {
            this.$confirm("确认删除此数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteElectricCharge({
                    electric_charge_id: row.electric_charge_id
                }).then(res => {
                    if (res && res.error_code == 0) {
                        this.$message({
                            message: res.error_msg,
                            type: "success"
                        });
                        if (
                            this.totalNum -
                                (this.pageNum - 1) * this.pageSize ==
                            1
                        ) {
                            this.pageNum =
                                this.pageNum == 1
                                    ? this.pageNum
                                    : this.pageNum - 1;
                        }
                        this.getChargeListElec();
                    }
                });
            });
        },
        editComplete() {
            this.editVisible = false;
            this.getChargeListElec();
        },
        addComplete() {
            this.addVisible = false;
            this.getChargeListElec();
        },
        exportExcel() {
            this.$refs["modelRef"].validate(valid => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: "下载中",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    api.getElecPowerExcel({
                        show_month: this.model.show_month
                    }).then(res => {
                        if (res) {
                            const content = res;
                            const blob = new Blob([content]);
                            const fileName =
                                this.model.show_month + "电费结算" + ".xlsx";
                            if (window.navigator.msSaveOrOpenBlob) {
                                navigator.msSaveBlob(blob, fileName);
                            } else {
                                let link = document.createElement("a");
                                link.href = window.URL.createObjectURL(blob);
                                link.download = fileName;
                                document.body.appendChild(link);
                                let evt = document.createEvent("MouseEvents");
                                evt.initEvent("click", false, false);
                                link.dispatchEvent(evt);
                                document.body.removeChild(link);
                            }
                            this.$message({
                                message: "下载成功！",
                                type: "success"
                            });
                        }
                        loading.close();
                    });
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getChargeListElec();
        },
        /**
         * 列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getChargeListElec();
        }
    }
};
</script>
<style lang="scss">
.check_ele_wrap {
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    .search-wrap {
        text-align: right;
        margin-bottom: 20px;
    }
}
</style>
